import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

// prettier-ignore
@Pipe({
  name: 'sanitizeHtml',
  standalone: true,
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(
    private readonly sanitizer: DomSanitizer
  ) {}
  /**
   * transform method
   * @param value value
   * @returns html
   */
  transform(
    value: string,
  ): SafeHtml {
    try {
      if (value) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
      }
      return '';
    } catch {
      return value as unknown as SafeHtml;
    }
  }

}
